import Autosuggest from 'react-autosuggest';

/**
 * This class hack appears to work for the selection to stay focused on the suggestion list even the mouse moved away.
 * It prevent the triggering of resetHighlightedSuggestionOnMouseLeave when onMouseLeave is triggered
 */
class CustomAutoSuggest extends Autosuggest {

    constructor(props) {
        const { preventResetHighlightedSuggentionOnMouseLeave } = props;
        super(props);

        if (preventResetHighlightedSuggentionOnMouseLeave) {
            const itemPropsOrig = this.itemProps;
            this.itemProps = function (_ref) {
                const customItemProps = itemPropsOrig(_ref);
                delete customItemProps.onMouseLeave;
                return customItemProps;
            };
        }
    }

}

export { CustomAutoSuggest };
